import httpService from "./httpService";
import type { PaginatedResponse, PortfolioListItem } from "../types/productV3";

export interface ProviderFlagship {
  providerId: number;
  providerName: string;
  flagship: {
    portfolioId: number;
    title: string;
    visibility: "PUBLIC" | "PRIVATE" | "SUBSCRIBER";
    deletedAtUtc: string | null;
    updatedAtUtc: string;
  } | null;
}

const BASE = "/v3/admin/products/flagships";
const ACTOR_AUTH = { requiresAuth: true, requestScope: "actor" as const, cache: "no-store" as const };

async function allPages<T>(path: string, signal?: AbortSignal): Promise<T[]> {
  const entries: T[] = [];
  let page = 1;
  let totalPages = 1;
  do {
    const response = await httpService.get<PaginatedResponse<T>>(
      `${path}?page=${page}&pageSize=100`, { ...ACTOR_AUTH, signal }
    );
    entries.push(...response.data.items);
    totalPages = response.data.totalPages;
    page += 1;
  } while (page <= totalPages);
  return entries;
}

export const adminFlagshipService = {
  listAll(signal?: AbortSignal): Promise<ProviderFlagship[]> {
    return allPages<ProviderFlagship>(BASE, signal);
  },
  portfolios(providerId: number, signal?: AbortSignal): Promise<PortfolioListItem[]> {
    return allPages<PortfolioListItem>(`/v3/products/providers/${providerId}/portfolios`, signal);
  },
  async designate(providerId: number, portfolioId: number): Promise<ProviderFlagship> {
    const response = await httpService.put<ProviderFlagship>(`${BASE}/${providerId}`, { portfolioId }, ACTOR_AUTH);
    return response.data;
  },
  async remove(providerId: number): Promise<void> {
    await httpService.delete(`${BASE}/${providerId}`, ACTOR_AUTH);
  },
};
